// source: imports/options/deltalake_table_name.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() {
  if (this) {
    return this;
  }
  if (typeof window !== 'undefined') {
    return window;
  }
  if (typeof global !== 'undefined') {
    return global;
  }
  if (typeof self !== 'undefined') {
    return self;
  }
  return Function('return this')();
}.call(null));

goog.exportSymbol(
    'proto.com.chegg.rio.metadata.deltalake.DeltaLakeTableName', null, global);
/**
 * @enum {number}
 */
proto.com.chegg.rio.metadata.deltalake.DeltaLakeTableName = {
  UNKNOWN_DELTALAKETABLENAME: 0,
  VIEW: 1,
  NEW_USER_SESSION: 2,
  MARKETING_CHANNEL_ATTRIBUTION: 3,
  COMMERCE: 4,
  PURCHASE: 5,
  INTERACTION: 6,
  NOTIFICATION: 7,
  COMMERCE_ORDERLINE: 8,
  COMMERCE_PAYMENT: 9,
  COMPONENT: 10,
  PURCHASE_PRODUCTINFO: 11,
  CONTENT_PROCESS: 12,
  SUCCESS: 13,
  USER_ACCOUNT_ACTION: 14,
  PARTNER_SUBSCRIPTION: 15,
  LLM: 16,
  CHATSTORE: 17,
  MODEL_ABUSE_DETECTION: 18,
  VIEW_SEARCHRESULTS: 19,
  LABEL_INFO: 20,
  ANNOTATION_LABELLING_INFO: 21,
  ANNOTATION_LABELLING_INFO_LABELINFO: 22,
  EXPERT_FRAUD_STATE_CHANGE: 23,
  EXPERT_ANSWER_CREATE_TRACKING: 24,
  EXPERT_TRAINING: 25,
  EXPERT_FRAUD: 26,
  DISCORD: 27,
  PLA: 28,
  EXPERT_AUTH0: 29,
  ORDER_EVALUATION_RESULTS: 30
};

goog.object.extend(exports, proto.com.chegg.rio.metadata.deltalake);



//////////////////
// WEBPACK FOOTER
// ./node_modules/@chegg/rio-event-schema-web/dist/imports/options/deltalake_table_name_pb.js
// module id = 1448
// module chunks = 11